export default "__VITE_ASSET__7kSRL0bO__"